class SectionLogoVideoSignUp implements ng.IComponentController {
    ltTitle: string;
    description: string;
    brandLogo: string;
    sbTitle: string;
    text: string;
    logo: boolean;
    image: anm.BaseImage;
    video: anm.LandingVideo;
    background: anm.LandingBackground;

    constructor(private $stateParams: ng.ui.IStateParamsService) {
        this.ltTitle     = this.$stateParams.t || this.ltTitle;
        this.description = this.$stateParams.d || this.description;
        this.text = this.$stateParams.d || this.text;
        this.logo      = _.isBoolean(this.logo) ? this.logo : true;
    }
}

angular.module('animatronApp.sectionLogoVideoSignUp', []).component('sectionLogoVideoSignUp', {
    bindings: {
        brandLogo: '<',
        logo: '<',
        ltTitle: '<',
        description: '<',
        text: '<',
        background: '<',
        sbTitle: '<',
        image: '<',
        video: '<'
    },
    controller: SectionLogoVideoSignUp,
    templateUrl: require('landing-template/components/sections/section-logo-video-sign-up.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionLogoVideoSignUp.ts